<template>
  <page>
    <form data-vv-scope="batchMatchForm">
      <!-- <v-card> -->
      <!-- <v-toolbar dense color="grey lighten-3" flat>
          <v-toolbar-title>Batch Match</v-toolbar-title>
        </v-toolbar> -->
      <!-- <v-card-text> -->
      <v-expansion-panels v-model="panel1" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Selection Criteria</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <cal-picker
                        v-model="batchMatchForm.setMatchDate"
                        :label="batchMatchLabel.setMatchDate"
                        :data-vv-as="batchMatchLabel.setMatchDate"
                        :error-messages="errors.collect('batchMatchForm.setMatchDate')"
                        data-vv-name="batchMatchForm.setMatchDate"
                        v-validate="doValidateDate"
                        :min="this.parseDateISO(this.tDateRange.effDate)"
                        :max="this.parseDateISO(this.tDateRange.expDate)"
                      ></cal-picker>
                    </v-flex>
                    <v-flex xs6> </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="batchMatchForm.accountNoFrom"
                        :label="batchMatchLabel.accountNoFrom"
                        :error-messages="errors.collect('batchMatchForm.accountNoFrom')"
                        data-vv-name="batchMatchForm.accountNoFrom"
                        :data-vv-as="batchMatchLabel.accountNoFrom"
                        append-icon="mdi-magnify"
                        @click:append="getInterHelpList('accountNoFrom')"
                        v-validate="doValAcctNoFrom"
                        @change="checkAcctNo($event, 'accountNoFrom')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="batchMatchForm.accountNoTo"
                        :label="batchMatchLabel.accountNoTo"
                        :error-messages="errors.collect('batchMatchForm.accountNoTo')"
                        data-vv-name="batchMatchForm.accountNoTo"
                        :data-vv-as="batchMatchLabel.accountNoTo"
                        append-icon="mdi-magnify"
                        @click:append="getInterHelpList('accountNoTo')"
                        v-validate="doValAcctNoTo"
                        @change="checkAcctNo($event, 'accountNoTo')"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="batchMatchForm.branch"
                        :label="batchMatchLabel.branch"
                        :error-messages="errors.collect('batchMatchForm.branch')"
                        data-vv-name="batchMatchForm.branch"
                        :data-vv-as="batchMatchLabel.branch"
                        append-icon="mdi-magnify"
                        @click:append="showBranchList = true"
                        readonly
                        v-validate="'required'"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="batchMatchForm.fund"
                        :label="batchMatchLabel.fund"
                        :error-messages="errors.collect('batchMatchForm.fund')"
                        data-vv-name="batchMatchForm.fund"
                        :data-vv-as="batchMatchLabel.fund"
                        append-icon="mdi-magnify"
                        @click:append="showFundList = true"
                        readonly
                        v-validate="'required'"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs6>
                      <v-text-field
                        v-model="batchMatchForm.suffix"
                        :label="batchMatchLabel.suffix"
                        :error-messages="errors.collect('batchMatchForm.suffix')"
                        data-vv-name="batchMatchForm.suffix"
                        :data-vv-as="batchMatchLabel.suffix"
                        append-icon="mdi-magnify"
                        @click:append="showAcctNoSfxList = true"
                        readonly
                        v-validate="'required'"
                      ></v-text-field>
                    </v-flex>
                    <!--
                      <v-flex xs6>
                        <v-autocomplete :items="matchOnList" v-model="batchMatchForm.matchOn" :label="batchMatchLabel.matchOn" item-text="label" item-value="value" :error-messages="errors.collect('batchMatchForm.matchOn')" data-vv-name="batchMatchForm.matchOn" :data-vv-as="batchMatchLabel.matchOn" v-validate="'required'"></v-autocomplete>
                      </v-flex>
                      -->
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel2" multiple>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div><v-icon>mdi-filter-variant</v-icon> Match By</div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <v-checkbox color="primary" :label="batchMatchLabel.documentNoAE" v-model="batchMatchForm.documentNoAE"></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox color="primary" :label="batchMatchLabel.cnReceiptAE" v-model="batchMatchForm.cnReceiptAE"></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox color="primary" :label="batchMatchLabel.vehRehNoReceiptAE" v-model="batchMatchForm.vehRehNoReceiptAE"></v-checkbox>
                    </v-flex>
                    <v-flex xs6>
                      <v-checkbox color="primary" :label="batchMatchLabel.polNoReceiptAE" v-model="batchMatchForm.polNoReceiptAE"></v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-flex lg6 xs12>
        <v-checkbox
          v-model="batchMatchForm.printRptRunTime"
          :label="batchMatchLabel.printRptRunTime"
          data-vv-name="printRptRunTime"
          :data-vv-as="batchMatchLabel.printRptRunTime"
        ></v-checkbox>
      </v-flex>
      <v-btn class="mr-2 mt-2" color="error" dark @click.prevent="doCancel">
        {{ actionLabel.cancel }}
        <v-icon dark right>mdi-exit-to-app</v-icon>
      </v-btn>
      <!-- <v-btn class="mr-2 mt-2" color="info" dark @click.prevent="doSchedule" :loading="submitting">
        {{ actionLabel.schedule }}
        <v-icon dark right>mdi-calendar</v-icon>
      </v-btn> -->
      <v-btn class="mt-2" color="primary" dark @click.prevent="doSubmit" :loading="submitting">
        {{ actionLabel.submit }}
        <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
      </v-btn>
    </form>
    <!-- Branch -->
    <v-dialog v-model="showBranchList" width="900px" persistent>
      <multi-branch-help-list
        :brn="batchMatchForm.branch"
        @close="showBranchList = false"
        @doAssign="doAssign('branch', $event)"
      ></multi-branch-help-list>
    </v-dialog>
    <!-- Fund -->
    <v-dialog v-model="showFundList" width="900px" persistent>
      <multi-fund-help-list :fnd="batchMatchForm.fund" @close="showFundList = false" @doAssign="doAssign('fund', $event)"></multi-fund-help-list>
    </v-dialog>
    <!-- AcctNoSfx -->
    <v-dialog v-model="showAcctNoSfxList" width="900px" persistent>
      <multi-acct-no-sfx-help-list
        :acctNoSfx="batchMatchForm.suffix"
        @close="showAcctNoSfxList = false"
        @doAssign="doAssign('acctNoSfx', $event)"
      ></multi-acct-no-sfx-help-list>
    </v-dialog>
    <!-- Intermediary -->
    <v-dialog v-model="showInterHelpList" width="1280px">
      <intermediary-help-list
        @close="showInterHelpList = false"
        perDebtTran="true"
        @assign-intermediary-data="assignInterInfo"
      ></intermediary-help-list>
    </v-dialog>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { commonMixins } from '@/mixins/common/commonMixin'
import { accountsAjaxCalls } from '@/mixins/accounting/accountsAjaxCalls'
import isAfter from 'date-fns/isAfter'
import { removeTime } from '@/utils/date'
import { parseISO } from 'date-fns'
import subDays from 'date-fns/subDays'
import MultiBranchHelpList from '@/components/core/common/dialog/MultiBranchHelpList'
import MultiFundHelpList from '@/components/core/common/dialog/MultiFundHelpList.vue'
import MultiAcctNoSfxHelpList from '@/components/core/common/dialog/MultiAcctNoSfxHelpList.vue'

export default {
  data() {
    return {
      batchMatchLabel: {
        setMatchDate: 'Set Match Date',
        accountNoFrom: 'Account No. From',
        accountNoTo: 'Account No. To',
        branch: 'Branch',
        fund: 'Fund',
        suffix: 'Suffix',
        matchOn: 'Match On',
        documentNoAE: 'Document No.',
        cnReceiptAE: 'Cover Note on Receipt',
        vehRehNoReceiptAE: 'Veh Reg No. on Receipt',
        polNoReceiptAE: 'Policy No. on Receipt',
        printRptRunTime: 'Print Runtime Parameters'
      },
      batchMatchForm: {
        setMatchDate: new Date(),
        accountNoFrom: '',
        accountNoTo: '',
        branch: 'All',
        fund: 'All',
        suffix: 'All',
        matchOn: '',
        documentNoAE: false,
        cnReceiptAE: false,
        vehRehNoReceiptAE: false,
        polNoReceiptAE: false,
        printRptRunTime: true
      },
      matchOnList: [
        { label: 'N - Net', value: 'N' },
        { label: 'G - Gross', value: 'G' }
      ],
      actionLabel: {
        cancel: 'Cancel',
        schedule: 'Schedule',
        submit: 'Submit'
      },
      submitting: false,
      mode: '',
      showInterHelpList: false,
      trandaterange: {},
      miscacctparams: [],
      isValAcctNo: true,
      isValAcctNoFrom: true,
      isValAcctNoTo: true,
      panel1: [0],
      panel2: [0],
      scheduleForm: {
        jobName: 'qrtzMatchTrans',
        jobDesc: 'Batch Match Transactions'
      },
      loading: false,
      showBranchList: false,
      showFundList: false,
      showAcctNoSfxList: false
    }
  },
  methods: {
    async doInit() {
      this.loading = true
      await Promise.all([this.$store.dispatch('commonsInit')])
      if (this.$store.state.accounts.init === 0) {
        await Promise.all([this.$store.dispatch('accountsInit')])
      }
      await Promise.all([this.$store.dispatch('batchMatchTransInit')])
      this.getCommonData('trandaterange', '008')
      this.getCommonData('miscacctparams').then(result => {
        this.batchMatchForm.matchOn = this.miscacctparams.defMchOn
      })
      this.loading = false
    },
    doAssign(fieldName, obj) {
      switch (fieldName) {
        case 'branch':
          this.batchMatchForm.branch = obj.finalSelectedItems.toString()
          this.showBranchList = false
          break
        case 'fund':
          this.batchMatchForm.fund = obj.finalSelectedItems.toString()
          this.showFundList = false
          break
        case 'acctNoSfx':
          this.batchMatchForm.suffix = obj.finalSelectedItems.toString()
          this.showAcctNoSfxList = false
          break
      }
    },
    doCancel() {
      this.$router.push({ name: 'matching' }).catch(() => {})
    },
    doSubmit() {
      this.$validator.validateAll('batchMatchForm').then(result => {
        if (result) {
          if (
            this.batchMatchForm.documentNoAE === false &&
            this.batchMatchForm.cnReceiptAE === false &&
            this.batchMatchForm.vehRehNoReceiptAE === false &&
            this.batchMatchForm.polNoReceiptAE === false
          ) {
            this.$toast.warning('Please check at least 1 Match By criteria')
          } else {
            this.doSchedule()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doSchedule() {
      const apiURI = this.menu.doSchedule
      if (apiURI) {
        try {
          this.submitting = true
          const result = this.$http.post(apiURI, this.batchMatchForm)
          if (result) {
            this.$toast.success('Job successfully submitted to batch job process.')
          }
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      }
    },
    assignInterInfo(data) {
      if (this.mode === 'accountNoFrom') {
        this.batchMatchForm.accountNoFrom = data.inter
      } else if (this.mode === 'accountNoTo') {
        this.batchMatchForm.accountNoTo = data.inter
      }
      this.showInterHelpList = false
    },
    getInterHelpList(fieldName) {
      this.mode = fieldName
      this.showInterHelpList = true
    },
    parseDateISO(value) {
      if (value) {
        return parseISO(value)
      }
    },
    async checkAcctNo(acctNo, field) {
      this.isValAcctNo = false
      if (field === 'accountNoFrom') {
        this.isValAcctNoFrom = false
        if (acctNo !== '' && acctNo !== null) {
          this.valAcctNo(acctNo).then(result => {
            if (result) {
              this.isValAcctNoFrom = this.isValAcctNo
              this.batchMatchForm.accountNoFrom = acctNo
            }
          })
        } else {
          this.batchMatchForm.accountNoFrom = null
        }
      } else if (field === 'accountNoTo') {
        this.isValAcctNoTo = false
        if (acctNo !== '' && acctNo !== null) {
          this.valAcctNo(acctNo).then(result => {
            if (result) {
              this.isValAcctNoTo = this.isValAcctNo
              this.batchMatchForm.accountNoTo = acctNo
            }
          })
        } else {
          this.batchMatchForm.accountNoTo = null
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.matching.batchMatchTrans.menu
    },
    tDateRange() {
      return this.trandaterange
    },
    doValidateDate() {
      const today = new Date()
      return 'required|valDate:' + today + '|valTranDateRange:' + this.tDateRange.effDate + ',' + this.tDateRange.expDate
    },
    doValAcctNoFrom() {
      if (this.batchMatchForm.accountNoFrom !== '' && this.batchMatchForm.accountNoFrom !== null && this.isValAcctNoFrom === false) {
        return 'entry|valAcctNoFrom:' + this.isValAcctNoFrom
      } else {
        return ''
      }
    },
    doValAcctNoTo() {
      if (
        (this.batchMatchForm.accountNoTo === '' || this.batchMatchForm.accountNoTo === null) &&
        this.batchMatchForm.accountNoFrom !== '' &&
        this.batchMatchForm.accountNoFrom !== null
      ) {
        return 'required'
      } else if (this.batchMatchForm.accountNoTo !== '' && this.batchMatchForm.accountNoTo !== null) {
        return 'required|valAcctNoTo:' + this.isValAcctNoTo
      } else {
        return ''
      }
    }
  },
  created() {
    this.$validator.extend('valDate', {
      getMessage(field, args) {
        return 'This date cannot be greater today'
      },
      validate(value, args) {
        let today = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(today))
        } else return true
      }
    })
    this.$validator.extend('valTranDateRange', {
      getMessage(field, args) {
        return 'Date not within permitted Date Range.(17)'
      },
      validate(value, args) {
        let effDate = args[0]
        let expDate = args[1]
        effDate = subDays(removeTime(effDate), 1)
        if (value) {
          return isAfter(removeTime(value), removeTime(effDate)) && !isAfter(removeTime(value), removeTime(expDate))
        } else return true
      }
    })
    this.$validator.extend('valAcctNoFrom', {
      getMessage(field, args) {
        return 'Invalid Account No'
      },
      validate(value, args) {
        let isValAcctNo = args[0]
        if (isValAcctNo === 'true') {
          return true
        } else {
          return false
        }
      }
    })
    this.$validator.extend('valAcctNoTo', {
      getMessage(field, args) {
        return 'Invalid Account No'
      },
      validate(value, args) {
        let isValAcctNo = args[0]
        if (isValAcctNo === 'true') {
          return true
        } else {
          return false
        }
      }
    })
  },
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin, MessageMixin, commonAjaxMixin, commonMixins, accountsAjaxCalls],
  components: {
    MultiBranchHelpList,
    MultiFundHelpList,
    MultiAcctNoSfxHelpList,
    IntermediaryHelpList
  }
}
</script>

<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
